module.exports = __webpack_public_path__ + "static/media/ball_5_5.fb6ab991.mp3";